exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-header h4[data-v-8baffb9c]{margin-bottom:0}.card-header h4.has-badge[data-v-8baffb9c]{display:inline-block}.card-body[data-v-8baffb9c] p:last-child{margin-bottom:0}li .card[data-v-8baffb9c]{margin-bottom:.75rem}li:last-child .card[data-v-8baffb9c]{margin-bottom:unset}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8baffb9c","scoped":true,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/Components/Card.vue
// module id = 99
// module chunks = 0 1 5 7 8 9 11